import styled from "styled-components";
import * as colors from "themes/colors";

export default styled.label`
  color: ${colors.colorDustyGrayApprox};
  font-family: telenor-regular;
  margin-right: 15px;
`;
